import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import styled from 'styled-components';

import { CancelButton, SaveButton } from '../common/ActionButtons';
import { DialogTitle } from '../common/dialogStyles';
import { CopyIcon } from '../common/icons';
import Modal from '../common/Modal';

type Props = {
  closeModal: () => void;
  action: () => void;
};

export const SaveOrDiscardModal: React.FC<Props> = observer((props: Props) => {
  const videoCreator = useVideoCreatorStore();
  const { action, closeModal } = props;
  const [isSaving, setIsSaving] = useState(false);

  const handleSaveData = async () => {
    if (isSaving) return;
    setIsSaving(true);
    await videoCreator.saveStoryAndVideo();
    setIsSaving(false);
  };

  return (
    <Modal isOpen closeModal={closeModal}>
      <Wrapper>
        <Heading>Current version not saved</Heading>
        <Buttons>
          <CancelButton
            disabled={isSaving}
            onClick={() => {
              if (isSaving) return;
              action();
            }}
          >
            Discard
          </CancelButton>
          <SaveButton
            disabled={isSaving}
            onClick={async () => {
              if (isSaving) return;
              await handleSaveData();
              action();
            }}
          >
            <CopyIcon />
            {isSaving ? 'Saving' : 'Save'}
          </SaveButton>
        </Buttons>
      </Wrapper>
    </Modal>
  );
});

const Wrapper = styled.div`
  width: 459px;
  height: 200px;
  border-radius: 16px;
  border: 1px solid var(--border);
  padding: 48px 24px;
  box-sizing: border-box;
  background: var(--background);
`;

const Heading = styled(DialogTitle)``;

const Buttons = styled.div`
  margin-top: 32px;
  display: flex;
  height: 48px;
  gap: 8px;
`;
